import * as React from 'react';

// tslint:disable:max-line-length
export const PoolIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M16 16h-1a5.534 5.534 0 0 1-3.5-1.229 5.581 5.581 0 0 1-7-.01A5.55 5.55 0 0 1 1 16H0v-2h1a3.525 3.525 0 0 0 2.735-1.277l.764-.91.766.909a3.566 3.566 0 0 0 5.462.01l.773-.943.773.943A3.5 3.5 0 0 0 15 14h1v2zM16 11h-1a5.534 5.534 0 0 1-3.5-1.229 5.581 5.581 0 0 1-7-.01A5.55 5.55 0 0 1 1 11H0V9h1a3.525 3.525 0 0 0 2.735-1.277l.764-.91.766.909a3.566 3.566 0 0 0 5.462.01l.773-.943.773.943A3.5 3.5 0 0 0 15 9h1v2zM16 6h-1a5.534 5.534 0 0 1-3.5-1.229A5.534 5.534 0 0 1 8 6a5.556 5.556 0 0 1-3.5-1.239A5.55 5.55 0 0 1 1 6H0V4h1a3.525 3.525 0 0 0 2.735-1.277l.765-.91.766.909A3.525 3.525 0 0 0 8 4a3.5 3.5 0 0 0 2.727-1.268l.773-.943.773.943A3.5 3.5 0 0 0 15 4h1v2z" />
    </g>
  </svg>
);
